// extracted by mini-css-extract-plugin
export var productContentCard = "product-content-card-module--product-content-card--C5ipM";
export var productContentCard__title = "product-content-card-module--product-content-card__title--EQeMJ";
export var productContentCard__desc = "product-content-card-module--product-content-card__desc--fiKvR";
export var productContentCard__button = "product-content-card-module--product-content-card__button--egDXr";
export var productContentCard_active = "product-content-card-module--product-content-card_active--XN2b7";